import React, { useState } from "react";

const BecomeVendor = () => {

  const [vendorForm, setVendorForm] = useState({
    email: "",
    password: "",
    first_name: "",
    last_name: "",
    shop_name: "",
    shop_url: "",
    company_name: "",
    company_id: "",
    vat_tax: "",
    bank_name: "",
    iban: "",
    phone: "",
    account_type: "vendor"
  });

  const handleVendorChange = (e) => {
    setVendorForm({
      ...vendorForm,
      [e.target.name]: e.target.value
    });
  };

  const handleVendorSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch("https://ecom.brightcodeapp.com/wp-json/custom-api/v1/dokan-register-vendor", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(vendorForm)
      });

      const data = await res.json();

      if (!res.ok) {
        return alert(data.message || "Vendor registration failed ❌");
      }

      alert("Vendor Registered Successfully 🎉");
      console.log("VENDOR REGISTER:", data);

    } catch (err) {
      console.log("Vendor Register Error:", err);
    }
  };

  return (
    <section className="account py-80">
      <div className="container container-lg">
        <div className="row justify-content-center">
          <div className="col-xl-8">
            <form onSubmit={handleVendorSubmit}>
              <div className="border border-gray-100 rounded-16 px-24 py-40">

                <h4 className="text-center mb-40">Become A Vendor</h4>

                <div className="row">

                  <div className="col-md-6 mb-24">
                    <label className="text-lg fw-medium">Email Address *</label>
                    <input type="email" className="common-input" name="email" onChange={handleVendorChange} required />
                  </div>

                  <div className="col-md-6 mb-24">
                    <label className="text-lg fw-medium">Password *</label>
                    <input type="password" className="common-input" name="password" onChange={handleVendorChange} required />
                  </div>

                  <div className="col-md-6 mb-24">
                    <label className="text-lg fw-medium">First Name *</label>
                    <input type="text" className="common-input" name="first_name" onChange={handleVendorChange} required />
                  </div>

                  <div className="col-md-6 mb-24">
                    <label className="text-lg fw-medium">Last Name *</label>
                    <input type="text" className="common-input" name="last_name" onChange={handleVendorChange} required />
                  </div>

                  <div className="col-md-6 mb-24">
                    <label className="text-lg fw-medium">Shop Name *</label>
                    <input type="text" className="common-input" name="shop_name" onChange={handleVendorChange} required />
                  </div>

                  <div className="col-md-6 mb-24">
                    <label className="text-lg fw-medium">Shop URL *</label>
                    <input
                      type="text"
                      className="common-input"
                      name="shop_url"
                      placeholder="https://ecom.brightcodeapp.com/store/your-shop"
                      onChange={handleVendorChange}
                      required
                    />
                  </div>

                  <div className="col-md-6 mb-24">
                    <label className="text-lg fw-medium">Company Name</label>
                    <input type="text" className="common-input" name="company_name" onChange={handleVendorChange} />
                  </div>

                  <div className="col-md-6 mb-24">
                    <label className="text-lg fw-medium">Company ID / EUID Number</label>
                    <input type="text" className="common-input" name="company_id" onChange={handleVendorChange} />
                  </div>

                  <div className="col-md-6 mb-24">
                    <label className="text-lg fw-medium">VAT / TAX ID</label>
                    <input type="text" className="common-input" name="vat_tax" onChange={handleVendorChange} />
                  </div>

                  <div className="col-md-6 mb-24">
                    <label className="text-lg fw-medium">Name of Bank</label>
                    <input type="text" className="common-input" name="bank_name" onChange={handleVendorChange} />
                  </div>

                  <div className="col-md-6 mb-24">
                    <label className="text-lg fw-medium">Account / IBAN</label>
                    <input type="text" className="common-input" name="iban" onChange={handleVendorChange} />
                  </div>

                  <div className="col-md-6 mb-24">
                    <label className="text-lg fw-medium">Phone Number *</label>
                    <input type="tel" className="common-input" name="phone" onChange={handleVendorChange} required />
                  </div>

                  <div className="col-md-12 mb-24">
                    

                    <label className="text-lg fw-medium ms-4">
                      <input
                        type="radio"
                        name="account_type"
                        value="vendor"
                        defaultChecked
                        onChange={handleVendorChange}
                      />{" "}
                      I am a vendor
                    </label>
                  </div>

                  <div className="col-md-12 mb-24">
                    <p style={{ fontSize: "14px", color: "#777" }}>
                      Your personal data will be used to support your experience throughout this website,
                      to manage access to your account, and for other purposes described in our privacy policy.
                    </p>
                  </div>

                  <div className="col-md-12 text-center mt-20">
                    <button type="submit" className="btn btn-main py-18 px-40">
                      Become Vendor
                    </button>
                  </div>

                </div>

              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BecomeVendor;